import clsx from "clsx";
import type { MouseEvent, ReactNode } from "react";

interface ModalBackdropProps {
  onClose: () => void;
  children: ReactNode;
  /** z-index, alignment, scrim opacity — defaults to bottom-sheet overlay. */
  className?: string;
}

const DEFAULT_OVERLAY = "z-50 items-end bg-black/70";

export function ModalBackdrop({ onClose, children, className }: ModalBackdropProps) {
  return (
    <div
      className={clsx("fixed inset-0 flex justify-center p-4", className ?? DEFAULT_OVERLAY)}
      onClick={onClose}
    >
      <div onClick={(e: MouseEvent) => e.stopPropagation()} className="contents">
        {children}
      </div>
    </div>
  );
}
